import { render, staticRenderFns } from "./MaterialEvaluacion.vue?vue&type=template&id=7c5b0c2b"
import script from "./MaterialEvaluacion.vue?vue&type=script&lang=js"
export * from "./MaterialEvaluacion.vue?vue&type=script&lang=js"
import style0 from "./MaterialEvaluacion.vue?vue&type=style&index=0&id=7c5b0c2b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports